/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum UserUsage {
  Undefined = 'Undefined',
  SustainableSourcing = 'SustainableSourcing',
  AddingRegionToMap = 'AddingRegionToMap',
  Other = 'Other',
}
